import { provideSingleton } from '@bcf-vanilla-ts-v1-shared/di/provide-singleton';
import type { Observable } from 'rxjs';
import type { HttpOptions } from './types';

export type PreInterceptIncomingRequest = {
  url: string;
  method: 'GET';
  httpOptions?: HttpOptions;
};

export interface PreInterceptContract {
  doPreIntercept(_request: PreInterceptIncomingRequest): Observable<Response> | undefined;
}

export class HttpClientPreInterceptor implements PreInterceptContract {
  public doPreIntercept(_request: PreInterceptIncomingRequest): Observable<Response> | undefined {
    return undefined;
  }
}
export function provideHttpClientPreInterceptor(): HttpClientPreInterceptor {
  return provideSingleton(HttpClientPreInterceptor, () => new HttpClientPreInterceptor());
}
